import style from './index.scss';
import { Component } from 'preact';
import SubHeader from '../layout/subheader/';
import { Link } from 'preact-router/match';

class Downloads extends Component {
	constructor(props) {
		super(props);
		this.state = {
			downloads: false
		};
	}
	componentWillMount(props){
		if (typeof window !== 'undefined'){
			window.scrollTo(0, 0);
		}
		this.setState({ loading: true });
		let basepath = window.location.host.includes('localhost') ? '/' : '/';
		fetch(basepath + 'assets/downloads/downloads.json')
			.then((response) => response.json())
			.then((downloadsJSON) => {

				this.setState({
					downloads: downloadsJSON,
					loading: false
				});
			}).catch((error) => {
				this.setState({ downloads: false });
			});

	}
	componentDidMount(){
	}

	render(){
		if (!this.state.downloads){
			return <h1>Loading Downloads</h1>;
		}

		const { downloads } = this.state || {};
		let basepath = window.location.host.includes('localhost') ? '/' : '/';
		return (
			<div>
				<p style={{ textAlign: 'center' }}>
					Just click on the colouring sheet to download the PDF then print and colour!
					<br />

					Share your coloured sheets on Instagram <a href={'http://instagram.com/charlottefilshie'} target={'_blank'}>@charlottefilshie</a> <em><a href={'https://www.instagram.com/explore/tags/dinosaursdoingstuff/'}>#dinosaursdoingstuff</a></em>
				</p>
				{downloads.items && downloads.items.map(e => {
					let activityribbon = e.ribbon ? (<div class={'ribbon'}><em class="ribbon--inner">{e.ribbon}</em></div>) : null;
					return (
						<a className={'layout__activity'} target={'_blank'} download={e.file} href={basepath + 'assets/downloads/' + e.file}>
							{activityribbon}
							<img src={basepath + e.thumb} />
							<span>{e.subtitle}</span>
							<h4>{e.title}</h4>
						</a>);
				}
				)}
				<p style={{ textAlign: 'center', width: '100%',float: 'left',clear: 'both' }}>
					Not for distribution or re-sale, if you would like to share, please credit me in full.
				</p>

			</div>
		);
	}
}

export default Downloads;



// WEBPACK FOOTER //
// ./components/downloads/index.js